/* src/app/modules/spare-parts/service-tickets-table-mobile/service-tickets-table-mobile.component.scss */
:host {
  display: block;
}
.tickets-mobile {
  margin-top: 1rem;
  gap: 1rem;
  display: flex;
  flex-direction: column;
}
.tickets-mobile .ticket {
  gap: 0.5rem;
  padding: 1rem;
  box-shadow: var(--shadow-raised);
  border-radius: var(--sh-card-border-radius);
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.tickets-mobile .ticket .item {
  display: flex;
  flex-direction: column;
  width: calc(50% - 1rem);
}
.tickets-mobile .ticket .item > span:last-child {
  font-weight: 400;
}
.tickets-mobile .ticket .item--description {
  width: 100%;
}
.ticket[color=yellow] {
  border-left: 4px solid #ffd201;
}
.ticket[color=green] {
  border-left: 4px solid #009a38;
}
.ticket[color=red] {
  border-left: 4px solid #e7001d;
}
.ticket[color=grey] {
  border-left: 4px solid #808080;
}
.span-item-ticket-number {
  display: flex;
  white-space: nowrap;
}
.badge {
  margin-top: 7px;
}
.clipboard-icon {
  cursor: pointer;
  align-items: baseline;
  margin-top: -0.25rem;
  margin-left: 0.5rem;
  display: inline;
}
/*# sourceMappingURL=service-tickets-table-mobile.component.css.map */
